import { RouteConfig } from 'src/lib/routeConfig/RouteConfig';

export const NotFoundRoute = new RouteConfig({
  owners: ['Unowned'],
  definition: '/404',
});

export const BuildRoute = new RouteConfig({
  owners: ['Unowned'],
  definition: '/build',
});

export const RootRoute = new RouteConfig({
  owners: ['Unowned'],
  definition: '/',
});

export const legacySupportRoute = new RouteConfig({
  owners: ['technicalSupport'],
  definition: '/support',
});
